import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getSignOnURL(id) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.id = id;
    appendTokenName(data);
    return apiAction({
        types: ["GET_SSO_REQUESTED", "GET_SSO_SUCCESS", "GET_SSO_FAILED"],
        method: "POST",
        path: "/sso",
        body: data
    });
}

export function set_saml_config(formData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_saml_config = formData;
    appendTokenName(data);
    return apiAction({
        types: ["SET_SAML_REQUESTED", "SET_SAML_SUCCESS", "SET_SAML_FAILED"],
        method: "POST",
        path: "/admin/set_saml_config",
        body: data
    });
}

export function setSamlPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_SAML_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function update_saml_config(formData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_saml_config = formData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_SAML_REQUESTED", "UPDATE_SAML_SUCCESS", "UPDATE_SAML_FAILED"],
        method: "POST",
        path: "/admin/update_saml_config",
        body: data
    });
}

export function deleteSaml(samlId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_saml_config = {"saml_id": samlId};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_SAML_REQUESTED", "DELETE_SAML_SUCCESS", "DELETE_SAML_FAILED"],
        method: "POST",
        path: "admin/delete_saml_config",
        body: data
    });
}

export function get_saml_config(id) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    let target_saml_config = {};
    target_saml_config['saml_id'] = id;
    data.target_saml_config = target_saml_config;
    appendTokenName(data);
    return apiAction({
        types: ["GET_SAML_REQUESTED", "GET_SAML_SUCCESS", "GET_SAML_FAILED"],
        method: "POST",
        path: "/admin/get_saml_config",
        body: data
    });
}

export function get_saml_configs() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_SAML_CONFIGS_REQUESTED", "GET_SAML_CONFIGS_SUCCESS", "GET_SAML_CONFIGS_FAILED"],
        method: "POST",
        path: "/admin/get_saml_configs",
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionSaml.js